import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { EditHoldingsFormComponent } from '../../../shared/forms/holding/edit-holdings-form/edit-holdings-form.component';
import { IHolding } from '../../../shared/models/holding.model';
import { ISelectList } from '../../../shared/models/select-list.model';
import { HoldingService } from '../../../shared/services/holdings/holding.service';
import { LookupsService } from '../../../shared/services/lookups/lookups.service';
import { MessageService } from '../../../shared/services/message/message.service';
import { GatekeeperModalComponent } from '../../modal.component';

@Component({
  selector: 'gk-edit-holdings-modal',
  templateUrl: './edit-holdings-modal.component.html'
})
export class EditHoldingsModalComponent extends GatekeeperModalComponent<EditHoldingsModalComponent> {
  businessId: number;
  holdings: IHolding[];
  regions: ISelectList[];

  @ViewChild(EditHoldingsFormComponent, { static: true })
  editHoldingsForm: EditHoldingsFormComponent;

  constructor(
    private messageService: MessageService,
    private holdingsService: HoldingService,
    private lookupsService: LookupsService,
    public dialogRef: MatDialogRef<EditHoldingsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

    this.businessId = data.locals.businessId;
    this.holdings = _.cloneDeep(data.locals.holdings);
    this.lookupsService.regions$.subscribe(l => (this.regions = l));
  }

  saveHoldings() {
    return this.holdingsService
      .saveHoldings(this.businessId, this.holdings)
      .then(holdings => this.dialogRef.close(holdings))
      .then(() => this.messageService.showIcon(MessageTypeEnum.Success))
      .catch(r =>
        this.messageService.showMessage(MessageTypeEnum.Danger, r.error.title, {
          name: ''
        })
      );
  }
}
